"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-end;\n  pointer-events: none;\n  transition: background 0.25s linear;\n  background: ", ";\n  z-index: 2;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: white;\n  pointer-events: ", ";\n  transition: opacity 0.25s linear;\n  opacity: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterContainer = exports.PlayerFooterContainer = void 0;

var isNative_1 = require("../isNative");

var styled_1 = require("../styled");

var theme_1 = require("../theme");

exports.PlayerFooterContainer = (0, styled_1.styledContainer)(_templateObject(), function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact ? '@size-s' : isNative_1.isNative ? '@size-s' : '@size-l');
}, function (props) {
  return (0, theme_1.getSize)(props.theme, props.compact ? '@size-s' : isNative_1.isNative ? '@size-m' : '@size-xl');
}, function (props) {
  return props.visible ? 'all' : 'none';
}, function (props) {
  return props.visible ? 1 : 0;
});
exports.FooterContainer = (0, styled_1.styledContainer)(_templateObject2(), function (props) {
  return props.isAudio || isNative_1.isNative || !props.footerVisible ? 'transparent' : "linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.15) 68%,\n    rgba(0, 0, 0, 0.6) 100%\n  )";
});